import { callManagementConstants } from 'Constants/callManagement.constants';
import Request from 'Services/request';
import { alterQueryRequest, findCurrentPageRequest, queryParser } from 'Helpers/urlform'
import { request } from 'http';
import {  formatDateTime, millisToMinutesAndSeconds } from 'Components/Common/TimeStamp';
import { handleApiError } from 'Helpers/index';

const requestCallManagement = callManagement => ({
    type: callManagementConstants.CALL_MANAGEMENT_REQUEST,
    callManagement
})

const successCallManagement = callManagementObj => ({
    type: callManagementConstants.CALL_MANAGEMENT_GET_SUCCESS,
    callManagement: callManagementObj.data,
    totalRecords: callManagementObj.count,
    currentPage: callManagementObj.currentPage
})

const failureCallManagement = error => ({
    type: callManagementConstants.CALL_MANAGEMENT_FAILURE,
    error
})

function fetchCallManagement(SearchArray) {
    let url = '/calls';
    if (SearchArray && SearchArray.length > 0) {
        url = queryParser(url, SearchArray);
    }
    const currentPage = findCurrentPageRequest(SearchArray);
    return async (dispatch) => {
        dispatch(requestCallManagement({}));
        await Request.get(url, { })
            .then((response) => {
                const { data, count } = response;
                dispatch(successCallManagement({ data, count, currentPage }));
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureCallManagement(error.toString()));
                }
            });
    };
}

const requestCallManagementExportData = exportData => ({
  type: callManagementConstants.EXPORT_CALL_MANAGEMENT_REQUEST, 
  exportData
})

const successCallManagementExportData = exportDataObj => ({
  type: callManagementConstants.EXPORT_CALL_MANAGEMENT_SUCCESS,
  exportData: exportDataObj.data,
  totalRecords: exportDataObj.count
})

const failureCallManagementExportData = error => ({
  type: callManagementConstants.EXPORT_CALL_MANAGEMENT_FAILURE,
  error
})

function exportCallManagement(SearchArray) {
  let url = '/calls';
  if (SearchArray && SearchArray.length > 0) {
    url = queryParser(url, SearchArray);
  }
  const exportUrl = SearchArray && SearchArray.length > 0 ? `&exportType=true` : `?exportType=true`;
  url = `${ url }${ exportUrl }`;
  return async (dispatch) => {
    dispatch(requestCallManagementExportData({}));
    await Request.get(url, {})
        .then(response => {
            const { data, count } = response;
            const dataToUpdate = [];
            data && data.forEach(function(res){ 
                const resObj = {};
                resObj[ 'Call From' ] = res.callFrom; 
                resObj[ 'Call To' ] = res.callTo; 
                resObj[ 'Date & Time' ] = res.callDateAndTime && formatDateTime(res.callDateAndTime);
                resObj[ 'Call Type' ] = res.callType; 
                const callFrom = (res.outgoingCallDuration && res.outgoingCallDuration !== 0) ? millisToMinutesAndSeconds(res.outgoingCallDuration) : 0;
                const callTo = (res.incomingCallDuration && res.incomingCallDuration !== 0) ? millisToMinutesAndSeconds(res.incomingCallDuration) : 0;
                resObj[ 'Duration(Caller/Receiver)' ] = res.status !== 0 ? `${ callFrom }/${ callTo }` : '-'; 
                resObj[ 'Status' ] = res.status === 0 ? 'Missed' : 'Connected'; 
                dataToUpdate.push(resObj);
            });
            dispatch(successCallManagementExportData({ data: dataToUpdate, count }));
        })
        .catch((error) => {
            if(error) {
                handleApiError(error);
                dispatch(failureCallManagementExportData(error.toString()));
            }
        });
  };
}

export const CallManagementAction = {
    fetchCallManagement,
    exportCallManagement,
}
